import "./PricingCard.css";
const PricingCard = ({ title, price, image, features, buttonText }) => {

  const handlePayment = async () => {
    try {
      // Appel à ton backend pour créer un paiement
    const res = await fetch("https://stratedgeos.lu/create-payment-mollie.php", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ pack: title, amount: price.replace("€", "") })
    });


      const data = await res.json();

      if (data.url) { 
        console.log({ pack: title, amount: price.replace("€", "") });

        // Redirige l'utilisateur vers Mollie Checkout
        window.location.href = data.url;
      }
    } catch (error) {
      console.error("Erreur paiement:", error);
    }
  };

  return (
    <div
      className="card shadow-sm rounded-4 overflow-hidden"
      style={{ width: "18rem" }}
    >
      <div className="card-body text-center">
        <h5 className="card-title fw-bold mb-2">{title}</h5>
        <h6 className="card-subtitle mb-3 text-black fw-bold">{price}</h6>
        <img
          src={image}
          alt={title}
          className="img-fluid mb-3"
          style={{ maxHeight: "150px", objectFit: "contain" }}
        />
        <hr />
        <ul className="list-unstyled mt-3 mb-4 text-start px-3">
       {/*  {features.map((feature, index) => (
            <li key={index} className="text-danger">
              {feature}
            </li>
          ))}*/}
        </ul>
        <button
          className="btn btn-primary rounded-pill px-4 py-2"
          style={{ backgroundColor: "#003466", border: "none" }}
          onClick={handlePayment} // 🔥 Mollie payment handler
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default PricingCard;
